import QRCode from 'qrcode'
import { FC, memo, useState, useEffect } from 'react'
import styles from './index.module.scss'
import bg from '@/assets/icons/qrcodeBg.svg'

interface AddressQRCodeProps {
  value: string
  logo: string
}

const AddressQRCode: FC<AddressQRCodeProps> = ({ value, logo }) => {
  const [dataUrl, setDataUrl] = useState<string>()

  useEffect(() => {
    if (value) {
      QRCode.toDataURL(value, { width: 160, margin: 0 }).then(url => setDataUrl(url))
    }
  }, [value])

  return (
    <div className={styles.container} style={{ backgroundImage: `url(${bg})` }}>
      {dataUrl && <img src={dataUrl} alt="" width={160} height={160} />}
      <img
        src={logo}
        alt=""
        className={styles.logo}
        style={{ visibility: dataUrl ? 'visible' : 'hidden' }}
      />
    </div>
  )
}

export default memo(AddressQRCode)
